import { camelCase } from 'lodash';
import React from 'react';
import { TextField } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
export const FormConfigTitleDescription = () => {
    const { formState, updateElement } = useFormContext();
    const element = formState.selectedFormElement;
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, multiline: true, className: 'element-title', variant: 'outlined', label: 'Question', value: element.title, onChange: event => {
                    const title = event.target.value;
                    const key = camelCase(element.title);
                    updateElement({ title, key });
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, multiline: true, className: 'element-description', variant: 'outlined', label: 'Description', value: element.description || '', onChange: event => {
                    const description = event.target.value;
                    updateElement({ description });
                } }))));
};
export default FormConfigTitleDescription;
//# sourceMappingURL=FormConfigTitleDescription.js.map